import Polygon from "./polygon";
import buildUUID from '../utils/buildUUID.js'

// 写两种加载方法，一种是根据火星api的，一种是根据cesium的
// 火星api由于它暂时还没有支持立体边框和高亮的功能，之后如果火星版本有对这一块做更新的话可以使用火星api，现在暂时先用原生的cesium
class waterPolygon extends Polygon {
  constructor(obj, callback){
    super(obj)

    const { height, normalMap, frequency, animationSpeed, amplitude, specularIntensity, baseWaterColor, blendColor, isCesium, baseColorRGB, blendColorRGB, opacity, outlineColorRGB, outlineOpacity, id, name, url, extrudedHeight, bottomHeight, colorByMaxHeight, highlight, baseColorHL } = obj
    if(isCesium){
      this._initObj = {
        id: id ? id : buildUUID(),
        name: name ? name : '水体模型',
        url: url ? url : '',
        baseWaterColor: baseColorRGB && baseColorRGB.length !== 0 ? baseColorRGB : [0, 102, 179],
        blendColor: blendColorRGB && blendColorRGB.length !== 0 ? blendColorRGB : [0, 102, 179],
        opacity: opacity !== null ? opacity : 0.7,
        normalMap: normalMap ? normalMap : 'img/textures/waterNormals.jpg',
        frequency: frequency !== null ? frequency : 8000.0,
        animationSpeed: animationSpeed !== null ? animationSpeed : 0.02,
        amplitude: amplitude !== null ? amplitude : 5.0,
        specularIntensity: specularIntensity !== null ? specularIntensity : 0.8,
        extrudedHeight: extrudedHeight !== null ? extrudedHeight : 100,
        bottomHeight: bottomHeight !== null ? bottomHeight : 0,
        colorByMaxHeight: colorByMaxHeight !== null ? colorByMaxHeight : 20.0, // 分层设置边框颜色
        outlineColorRGB: outlineColorRGB && outlineColorRGB.length !== 0 ? outlineColorRGB : [255,255,0], // 与colorByMaxHeight二选一，outlineColorRGB是统一的边框颜色（不跟高度做区分）
        outlineOpacity: outlineOpacity !== null ? outlineOpacity : 0.6, // 需要与outlineColorRGB合用构成Cesium.Color(0, 0.4, 0.7, 0.7)
        highlight: highlight || false,
        baseColorHL: baseColorHL ? baseColorHL : new Cesium.Color(0, 0.4, 0.7, 0.7)
      }
    }else{
      this._styleOptions = {
        ...this._styleOptions,
        height: height !== null ? height : 0.0,
        normalMap: normalMap ? normalMap : 'img/textures/waterNormals.jpg',
        frequency: frequency !== null ? frequency : 8000.0,
        animationSpeed: animationSpeed !== null ? animationSpeed : 0.02,
        amplitude: amplitude !== null ? amplitude : 5.0,
        specularIntensity: specularIntensity !== null ? specularIntensity : 0.8,
        baseWaterColor: baseWaterColor ? baseWaterColor : new Cesium.Color(0, 0.4, 0.7, 0.7),
        blendColor: blendColor ? blendColor : new Cesium.Color(0, 0.4, 0.7, 0.7),
      }
      this._symbol = {
        ...this._symbol,
        styleOptions: this._styleOptions,
        callback: callback && (typeof callback === 'function') ? callback : null
      }
      this._initObj = {
        ...this._initObj,
        symbol: this._symbol
      }
    }
  }
}

waterPolygon.prototype.addToMapByCesium = function(map){
  const scene = map.scene;
  const that = this
  fetch(this._initObj.url).then(function (response) {
    return response.json();
  }).then(function (data) {
    console.log('water',data);
    var instances = [];
    var lineGeom = [];
    var primitiveCollection = new Cesium.PrimitiveCollection();
    var points = [];
    var ids = [];
    var maxHeights = [];
    var minHeights = [];
    scene.globe.enableLighting = false;
    for (var i = 0; i < data.features.length; i++) {
      var riverPointArr = data.features[i].geometry.coordinates[0][0];
      var riverPoint = [];
      for (var j = 0; j < riverPointArr.length; j++) {
        riverPoint.push(riverPointArr[j][0]);
        riverPoint.push(riverPointArr[j][1]);
      }
      ids.push(data.features[i].id);
      points.push(riverPoint);
      maxHeights.push(data.features[i].properties.maxhight ? data.features[i].properties.maxhight : that._initObj.extrudedHeight);
      minHeights.push(data.features[i].properties.minhight ? data.features[i].properties.minhight : that._initObj.bottomHeight);
    }
    for (var k = 0; k < points.length; k++) {
      var polygon1 = new Cesium.PolygonGeometry({
        polygonHierarchy: new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(points[k])),
        extrudedHeight: maxHeights[k], // 水面高度
        height: minHeights[k], // 底部高度
        vertexFormat: Cesium.EllipsoidSurfaceAppearance.VERTEX_FORMAT,
        allowPicking: true
      });
      var outlineGeometry = new Cesium.PolygonOutlineGeometry({
        polygonHierarchy: new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(points[k])),
        extrudedHeight: maxHeights[k], // 水面高度
        height: minHeights[k], // 底部高度
        vertexFormat: Cesium.EllipsoidSurfaceAppearance.VERTEX_FORMAT,
        allowPicking: true
      });
      var geometry = new Cesium.GeometryInstance({
        geometry: polygon1,
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(1, 1, 0, 0.6))
        },
        id: ids[k]
      });
      var lgeometry = new Cesium.GeometryInstance({
        geometry: outlineGeometry,
        attributes: {
          color: that._initObj.colorByMaxHeight ? (maxHeights[k] > that._initObj.colorByMaxHeight ? Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(1.0, 0.0, 0.0, 1.0)) : Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(0.0, 1.0, 0.0, 1.0))) : (Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(that._initObj.outlineColorRGB[0] / 255.0, that._initObj.outlineColorRGB[1] / 255.0, that._initObj.outlineColorRGB[2] / 255.0, that._initObj.outlineOpacity)))
        }
      });
      instances.push(geometry);
      lineGeom.push(lgeometry);
    }
    var river1 = new Cesium.Primitive({
      geometryInstances: instances,
      releaseGeometryInstances: false,
      appearance: new Cesium.EllipsoidSurfaceAppearance(),
      show: true
    });
    var river2 = new Cesium.Primitive({
      geometryInstances: lineGeom,
      appearance: new Cesium.PerInstanceColorAppearance({
        flat: true
      })
    });
    var riverMaterial = new Cesium.Material({
      fabric: {
        type: 'Water',
        uniforms: {
          baseWaterColor:  new Cesium.Color(that._initObj.baseWaterColor[0] / 255.0, that._initObj.baseWaterColor[1] / 255.0, that._initObj.baseWaterColor[2] / 255.0, that._initObj.opacity),
          blendColor: new Cesium.Color(that._initObj.blendColor[0] / 255.0, that._initObj.blendColor[1] / 255.0, that._initObj.blendColor[2] / 255.0, that._initObj.opacity),
          normalMap: that._initObj.normalMap,
          frequency: that._initObj.frequency,
          animationSpeed: that._initObj.animationSpeed,
          amplitude: that._initObj.amplitude,
          specularIntensity: that._initObj.specularIntensity
        }
      }
    });
    console.log('material',riverMaterial);
    river1.appearance.material = riverMaterial;
    primitiveCollection.add(river1);
    primitiveCollection.add(river2);
    primitiveCollection._zIndex = 1;
    primitiveCollection.id = that._initObj.id;
    primitiveCollection.name = that._initObj.name;
    scene.primitives.add(primitiveCollection);
  })

  this.highlightWater(map)
}

waterPolygon.prototype.highlightWater = function(map){
  const that = this
  let currentObjectid
  let currentPrimitive
  let currentGeometry
  let selectedGeom

  map.on(mars3d.EventType.click,function (e) {
    console.log('点击事件',e);
    if(e.pickedObject && e.czmObject && that._initObj.highlight){
      const pickObject = e.pickedObject;            

      if (Cesium.defined(pickObject) && Cesium.defined(pickObject.id)) {
        console.log(pickObject);
        if (pickObject.id === currentObjectid) {
          return;
        }
        if (Cesium.defined(currentObjectid)) {
          currentObjectid = undefined;
          currentPrimitive = undefined;
        }
      }
      if (
        Cesium.defined(pickObject) &&
        Cesium.defined(pickObject.id) &&
        Cesium.defined(pickObject.primitive)
      ) {
        console.log(pickObject, selectedGeom);
        if (selectedGeom) {
          map.scene.primitives.remove(selectedGeom);
        }
        currentObjectid = pickObject.id;
        currentPrimitive = pickObject.primitive;
        currentGeometry = currentPrimitive.geometryInstances.find(
          (item) => item.id === currentObjectid
        );
        selectedGeom = new Cesium.Primitive({
          geometryInstances: currentGeometry,
          releaseGeometryInstances: false,
          appearance: new Cesium.PerInstanceColorAppearance({
            flat: true,
          }),
          show: true,
        });
        map.scene.primitives.add(selectedGeom);
        currentPrimitive.appearance.material.uniforms.baseWaterColor = that._initObj.highlight ? that._initObj.baseColorHL : new Cesium.Color(0, 0.4, 0.7, 0.7);
      }
    }else{
      if (selectedGeom) {
        map.scene.primitives.remove(selectedGeom);
      }
    }
  })
}

export default waterPolygon